// extracted by mini-css-extract-plugin
export default {"container":"InputComponent_container__d9iMx","preview":"InputComponent_preview__59KYk","extras":"InputComponent_extras__+4f7B"};